import { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
// @ts-expect-error module not typed
import { getEmail } from 'conversations-internal-schema/connected-email-account/operators/connectedEmailAccountGetters';
import { getCheckConnectedAccounts } from 'conversations-thread-data/channel-configuration/public/operators';
import { isGenericChannelId } from 'conversations-thread-data/channel-configuration/public/types';
// @ts-expect-error module not typed

import UISelect from 'UIComponents/input/UISelect';
// TODO: move to composer-ui
import { ChannelCapabilitiesConfigContext } from 'conversations-thread-view/channel-capabilities/context/ChannelCapabilitiesConfigContext';
import { useHydratedChannelInstanceOptions } from '../hooks/useHydratedChannelInstanceOptions';
import FromEmailOption from './FromEmailOption';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledSelect = styled(UISelect).withConfig({
  displayName: "ChannelInstanceSelect__StyledSelect",
  componentId: "g2et6k-0"
})(["&&&{padding-left:0;padding-right:0;.Select-control{border:none;background:transparent;&:hover{box-shadow:none;}.Select-arrow-zone{display:none;}}}"]);
const ChannelInstanceSelect = ({
  inboxId,
  value,
  onChange
}) => {
  const {
    capabilitiesBlob,
    genericChannelId: editorConfigurationKey
  } = useContext(ChannelCapabilitiesConfigContext);
  const checkConnectedAccounts = Boolean(getCheckConnectedAccounts(capabilitiesBlob));
  const isValidGenericChannelId = editorConfigurationKey && isGenericChannelId(editorConfigurationKey);
  const genericChannelId = isValidGenericChannelId ? editorConfigurationKey : null;
  const {
    connectedAccounts,
    instanceOptions,
    loadingData
  } = useHydratedChannelInstanceOptions({
    inboxId,
    genericChannelId,
    checkConnectedAccounts
  });
  const handleChange = useCallback(({
    target: {
      value: nextValue
    }
  }) => {
    const nextConnectedAccount = connectedAccounts && connectedAccounts.find(account => {
      const connectedEmail = getEmail(account);
      return connectedEmail && connectedEmail.toLowerCase() === nextValue.toLowerCase();
    });
    onChange(nextValue, nextConnectedAccount);
  }, [connectedAccounts, onChange]);
  return /*#__PURE__*/_jsx(StyledSelect, {
    disabled: !isValidGenericChannelId,
    className: "channel-instance-select",
    buttonUse: "transparent",
    isLoading: loadingData,
    onChange: handleChange,
    options: instanceOptions,
    value: value,
    itemComponent: FromEmailOption,
    "data-selenium-test": "metadata-from-input"
  });
};
ChannelInstanceSelect.displayName = 'ChannelInstanceSelect';
ChannelInstanceSelect.propTypes = {
  inboxId: PropTypes.number,
  onChange: PropTypes.func,
  value: PropTypes.string
};
export default ChannelInstanceSelect;